/**
 * Типизированная версия Object.keys.
 *
 * @param obj Объект.
 * @returns Массив ключей.
 * @example
 * ```typescript
 * import { keys } from '@direct-frontend/stdlib';
 *
 * keys({ a: 1, b: 2 }); // ('a' | 'b')[]
 * Object.keys({ a: 1, b: 2 }); // string[]
 * ```
 */
export function keys(obj) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return Object.keys(obj);
}
